module.exports = __webpack_public_path__ + "79c1485519ff91c1c5ee7802dafe0e4c.pdf";